import isEmpty from 'validator/lib/isEmpty';
import isLength from 'validator/lib/isLength';
import isEmail from 'validator/lib/isEmail';
import trim from 'lodash/trim';

const MAX_NAME_LENGTH = 60;

export const SOCIAL_AUTH_STATE = {
  authorized: 'authorized',
  unauthorized: 'unauthorized',
  tokenIrrelevant: 'tokenIrrelevant',
};

export const validateEmail = (email) => {
  const messages = [];

  if (isEmpty(trim(email))) {
    messages.push('Please enter an email address');
  } else if (!isEmail(trim(email))) {
    messages.push('Email is invalid');
  }

  return {
    valid: messages.length === 0,
    messages,
  };
};

export const validateName = (name) => {
  const messages = [];

  if (name.match(/[^A-Za-z0-9&.,\-\s]/gi)) {
    messages.push('Only English characters are allowed');
  } else if (!isLength(name, { max: MAX_NAME_LENGTH })) {
    messages.push(`Names are limited to ${MAX_NAME_LENGTH} characters.`);
  }

  return {
    valid: messages.length === 0,
    messages,
  };
};

export const isUserFeatureEnabled = (user, featureFlag) => {
  if (!user) return false;

  const userFeatures = user.featureFlags || [];
  return userFeatures.includes(featureFlag);
};

export const MARKETING_USER_POSITION = {
  audienceDevelopmentManager: 'Audience Development Manager - Publishing',
  eCommerceShopOwner: 'eCommerce Shop Owner',
  onlineBusinessOwner: 'Online Business Owner',
  startupFounder: 'Startup Founder',
  agencyOwner: 'Agency Owner',
  copywriter: 'Copywriter',
  freelancerCopywriter: 'Freelancer/Copywriter',
  vpMarketing: 'VP Marketing/CMO',
  contentMarketer: 'Content Marketer',
  socialMediaManager: 'Social Media Manager',
  paidAdvertisingMarketer: 'Paid Advertising Marketer',
  seoMarketer: 'SEO Marketer',
  emailMarketer: 'Email Marketer',
  fullStackMarketer: 'Full-Stack Marketer',
  webDesigner: 'Web UI/UX Designer',
  influencer: 'Influencer',
  other: 'Other',
};

export const USER_SEGMENT = {
  copywriter: 'Copywriter',
  blogger: 'Blogger',
  performance: 'Performance',
  engagement: 'Engagement',
  acquisition: 'Acquisition',
  conversion: 'Conversion',
};

// Currently, almost all the "enum values" equal "visible labels"
export const getUserMarketingPositionLabel = (position) => {
  if (position === MARKETING_USER_POSITION.eCommerceShopOwner) {
    return 'Ecommerce Shop Owner';
  }
  return position;
};

export const USER_ROLE = {
  admin: 'admin',
  member: 'member',
};

const USER_ROLE_LABEL = {
  [USER_ROLE.admin]: 'Admin',
  [USER_ROLE.member]: 'Member',
};

export const getUserRoleLabel = (role) => {
  return USER_ROLE_LABEL[role] || role;
};

export const getUserRole = (user, customerId) => {
  const userCustomer = user?.customers?.find((customer) => customer.id === customerId);

  return userCustomer?.role;
};

export const isAdminRole = (role) => role === USER_ROLE.admin;

export const getUserName = ({ name, email }) => {
  if (name) return name;

  return email.split('@')[0];
};

export const getUserCompanySize = (user) => user?.companyInformation?.company_size;

export const getUserCountry = (user) => user?.country;
